var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_11730)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1161_11730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2653 31.4526C18.4551 31.4526 17.7123 31.2299 17.037 30.7843C16.3617 30.3388 15.8763 29.7376 15.5807 28.9805C15.4679 28.6997 15.5072 28.4352 15.6986 28.1868C15.8899 27.9384 16.1458 27.8142 16.4663 27.8142C16.6718 27.8142 16.8579 27.8828 17.0247 28.02C17.1915 28.1571 17.3275 28.327 17.4326 28.5296C17.6064 28.8565 17.8628 29.1113 18.2019 29.294C18.541 29.4767 18.8955 29.5681 19.2653 29.5681C19.8612 29.5681 20.3665 29.3613 20.7815 28.9477C21.1964 28.5341 21.4039 28.0304 21.4039 27.4366C21.4039 26.8428 21.1964 26.34 20.7815 25.9281C20.3665 25.5162 19.8612 25.3103 19.2653 25.3103H6.31726C6.04981 25.3103 5.8259 25.2197 5.64552 25.0384C5.46517 24.8572 5.375 24.6322 5.375 24.3635C5.375 24.0947 5.46517 23.8713 5.64552 23.6931C5.8259 23.5149 6.04981 23.4258 6.31726 23.4258H19.2653C20.3813 23.4258 21.3308 23.8159 22.1138 24.5962C22.8969 25.3765 23.2884 26.3227 23.2884 27.4347C23.2884 28.5466 22.8969 29.4943 22.1138 30.2776C21.3308 31.061 20.3813 31.4526 19.2653 31.4526ZM6.31726 16.6565C6.04981 16.6565 5.8259 16.5659 5.64552 16.3846C5.46517 16.2034 5.375 15.9784 5.375 15.7096C5.375 15.4409 5.46517 15.2174 5.64552 15.0392C5.8259 14.861 6.04981 14.7719 6.31726 14.7719H25.3057C26.1086 14.7719 26.7959 14.4851 27.3676 13.9116C27.9392 13.338 28.225 12.6485 28.225 11.8428C28.225 11.0372 27.9392 10.3509 27.3676 9.78389C26.7959 9.21689 26.1086 8.93339 25.3057 8.93339C24.7209 8.93339 24.188 9.08628 23.707 9.39205C23.226 9.69783 22.881 10.1161 22.6721 10.6469C22.5823 10.8533 22.4548 11.0315 22.2896 11.1815C22.1244 11.3315 21.9346 11.4065 21.7202 11.4065C21.4108 11.4065 21.1594 11.2937 20.966 11.068C20.7726 10.8424 20.7179 10.5873 20.8019 10.3027C21.1147 9.31806 21.6838 8.52962 22.5091 7.93732C23.3344 7.34499 24.2666 7.04883 25.3057 7.04883C26.6429 7.04883 27.7778 7.51518 28.7105 8.44788C29.6432 9.38055 30.1096 10.5155 30.1096 11.8527C30.1096 13.1898 29.6432 14.3248 28.7105 15.2575C27.7778 16.1901 26.6429 16.6565 25.3057 16.6565H6.31726ZM31.4269 28.32C31.1269 28.4026 30.8586 28.3501 30.6221 28.1622C30.3856 27.9744 30.2673 27.7235 30.2673 27.4094C30.2673 27.1947 30.3423 27.0044 30.4923 26.8387C30.6423 26.673 30.8205 26.5453 31.0269 26.4556C31.5743 26.2466 31.9968 25.9016 32.2942 25.4206C32.5917 24.9397 32.7404 24.4067 32.7404 23.8219C32.7404 23.0366 32.4615 22.3672 31.9037 21.8137C31.3459 21.2602 30.6754 20.9834 29.8923 20.9834H6.31726C6.04981 20.9834 5.8259 20.8928 5.64552 20.7115C5.46517 20.5303 5.375 20.3053 5.375 20.0365C5.375 19.7678 5.46517 19.5443 5.64552 19.3661C5.8259 19.1879 6.04981 19.0988 6.31726 19.0988H29.8923C31.2068 19.0988 32.3242 19.5597 33.2445 20.4816C34.1648 21.4034 34.6249 22.5169 34.6249 23.8219C34.6249 24.8623 34.3362 25.7958 33.7586 26.6224C33.181 27.449 32.4038 28.0148 31.4269 28.32Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_11730",
    x: -2.39805,
    y: -2.39805,
    width: 44.7961,
    height: 44.7961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.19902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_11730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_11730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1161_11730",
    x: 0.976953,
    y: 2.65078,
    width: 38.0461,
    height: 33.2004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.19902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_11730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_11730",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSelected);
export default __webpack_public_path__ + "static/media/wind-selected.6bbdb2ce0ef409792b923df70e3f0608.svg";
export { ForwardRef as ReactComponent };